import { Suspense, type FunctionComponent } from 'react';

import { useOneTimeMessagesDismissed } from '@trello/business-logic-react/member';
import { ChunkLoadErrorBoundary } from '@trello/error-boundaries';
import { useLazyComponent } from '@trello/use-lazy-component';

export const LazyGAWelcomeModal: FunctionComponent = () => {
  const { isOneTimeMessageDismissed } = useOneTimeMessagesDismissed();

  const isDismissed = isOneTimeMessageDismissed('beta-ga-welcome-modal');

  const GAWelcomeModal = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "personal-productivity-ga-welcome-modal" */ './GAWelcomeModal'
      ),
    { namedImport: 'GAWelcomeModal', preload: !isDismissed },
  );

  if (isDismissed) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <ChunkLoadErrorBoundary fallback={null}>
        <GAWelcomeModal />
      </ChunkLoadErrorBoundary>
    </Suspense>
  );
};
